import React, { Component } from 'react'
import AuthenticatedPage from '../../../containers/AuthenticatedPage'
import Tabs from '../../../components/Tabs'

import { getMessage } from '../../../lib/translator'

import RolesTab from './RolesTab'
import EndpointsTab from '../Endpoints'
import './style.css'

// Route target for /hr/roles. Two tabs — Roles and Endpoints — each a full ListingPage CRUD
// rendered WITHOUT `menu` (so only this wrapper's AuthenticatedPage draws the sidebar).
export default class RolesAndEndpoints extends Component {
  constructor(props) {
    super(props)
    this.state = { tab: 0 }
  }

  render() {
    return (
      <AuthenticatedPage
        menu={this.props.menu}
        className="roles-endpoints-page"
      >
        <h1 className="title">{getMessage('rolesEndpoints.heading')}</h1>
        <Tabs
          items={[getMessage('role.heading'), getMessage('endpoint.heading')]}
          default={this.state.tab}
          onClick={(index) => this.setState({ tab: index })}
        />
        {this.state.tab === 0 ? <RolesTab /> : <EndpointsTab />}
      </AuthenticatedPage>
    )
  }
}
